import { configureStore } from "@reduxjs/toolkit";
import { apiMiddleware } from "./middlewares";
import authReducer from "../redux/slices/authSlice";
import vendorOfferingReducer from "../redux/slices/vendor-offerings";
import vendorServiceReducer from "../redux/slices/vendor-services";
import vendorInfoReducer from "./slices/vendor-info";
import productInfoReducer from "./slices/product-info";
import catalogInfoReducer from "./slices/catalog-info";
import collectionInfoReducer from "./slices/collection-info";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    vendorOfferings: vendorOfferingReducer,
    vendorServices: vendorServiceReducer,
    vendorInfo: vendorInfoReducer,
    productInfo: productInfoReducer,
    catalogInfo: catalogInfoReducer,
    collectionInfo: collectionInfoReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
